import { withInstall } from '@element-plus/utils'
import Progress from './src/progress.vue'

export const ElProgress = withInstall(Progress)
export default ElProgress

export * from './src/progress'
export * from './src/hooks'
